import React, { useState, useEffect, useRef } from "react";
import OperationsConnector from "../Inventory/Connector/OperationsConnector";
import styled from "styled-components";
import Card from "../Generic/Card";
import { CSSTransition } from "react-transition-group";
import { Table, Tcol, Thead, Trow } from "../Generic/Table";
import close from "../Assets/Close.png";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Loader from "../Generic/Loader";
import EmptyState from "../Generic/EmptyState";
import { beautifyKey } from "../util/util";
import OrderService from "./Services/OrderService";
import { useLocation, useNavigate } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as Actions from "./Actions/index";
import { connect } from "react-redux";
import { errorNotification } from "../Generic/Notifications";
import { formatDisplayDate } from "../util/date.util";

const OrderStatuses = {
	CREATED: "CREATED",
	IN_QUEUE: "IN_QUEUE",
	IN_PROGRESS: "IN_PROGRESS",
	COMPLETED: "COMPLETED",
	CANCELLED: "CANCELLED",
	ABORTED: "ABORTED",
	ARCHIVED: "ARCHIVED",
};

const TaskStatuses = {
	ORDERED: "ORDERED",
	IN_QUEUE: "IN_QUEUE",
	IN_PROGRESS: "IN_PROGRESS",
	READY_TO_COLLECT: "READY_TO_COLLECT",
	COLLECT_INITIATED: "COLLECT_INITAITED",
	COLLECTING: "COLLECTING",
	SERVED: "SERVED",
	DISCARDING: "DISCARDING",
	DISCARDED: "DISCARDED",
	ABORTED: "ABORTED",
	FAILED: "FAILED",
};

const PaymentStatuses = {
	PAYMENT_PENDING: "PAYMENT_PENDING",
	PAYMENT_SUCCESSFUL: "PAYMENT_SUCCESSFUL",
	PAYMENT_FAILED: "PAYMENT_FAILED",
	REFUND_INITIATED: "REFUND_INITIATED",
	REFUND_PROCESSED: "REFUND_PROCESSED",
	REFUND_FAILED: "REFUND_FAILED",
};

const orderStatusMap = {
	[OrderStatuses.CREATED]: {
		statusMessage: "CREATED",
		status: 1,
		backColor: "#000000",
		textColor: "#FFFFFF",
	},
	[OrderStatuses.IN_QUEUE]: {
		statusMessage: "IN QUEUE",
		status: 2,
		backColor: "#f6ea76",
		textColor: "#776200",
	},
	[OrderStatuses.IN_PROGRESS]: {
		statusMessage: "IN PROGRESS",
		status: 3,
		backColor: "#54BF29",
		textColor: "#ffffff",
	},
	[OrderStatuses.COMPLETED]: {
		statusMessage: "COMPLETED",
		status: 5,
		backColor: "#008000",
		textColor: "#ffffff",
	},
	[OrderStatuses.CANCELLED]: {
		statusMessage: "CANCELLED",
		status: 6,
		backColor: "#d64a4a",
		textColor: "#ffffff",
	},
	[OrderStatuses.ABORTED]: {
		statusMessage: "ABORTED",
		status: 7,
		backColor: "#d64a4a",
		textColor: "#ffffff",
	},
	[OrderStatuses.ARCHIVED]: {
		statusMessage: "ARCHIVED",
		status: 8,
		backColor: "#d64a4a",
		textColor: "#ffffff",
	},
};

const paymentStatusMap = {
	[PaymentStatuses.PAYMENT_PENDING]: {
		status: "PAYMENT_PENDING",
		backColor: "#f6ea76",
		textColor: "#776200",
	},
	[PaymentStatuses.PAYMENT_SUCCESSFUL]: {
		status: "PAYMENT_SUCCESSFUL",
		backColor: "#008000",
		textColor: "#ffffff",
	},
	[PaymentStatuses.PAYMENT_FAILED]: {
		status: "PAYMENT_FAILED",
		backColor: "#d64a4a",
		textColor: "#ffffff",
	},
	[PaymentStatuses.REFUND_INITIATED]: {
		status: "REFUND_INITIATED",
		backColor: "#f6ea76",
		textColor: "#776200",
	},
	[PaymentStatuses.REFUND_PROCESSED]: {
		status: "REFUND_PROCESSED",
		backColor: "#008000",
		textColor: "#ffffff",
	},
	[PaymentStatuses.REFUND_FAILED]: {
		status: "REFUND_FAILED",
		backColor: "#d64a4a",
		textColor: "#ffffff",
	},
};

const RefundStatusClassName = {
	PAYMENT_PENDING: "status unused",
	PAYMENT_SUCCESSFUL: "status unused",
	PAYMENT_FAILED: "status unused",
	REFUND_INITIATED: "status in-progress",
	REFUND_PROCESSED: "status open",
	REFUND_FAILED: "status dead",
};

const Page = styled.div`
	height: max-content;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 0 1rem 2rem 1rem;
	scroll-behavior: smooth;
`;

const Header = styled.div`
	display: flex;
	font-size: 2rem;
	margin: 1rem 0 0 0.5rem;
`;

const Div = styled.div`
	position: ${(props) => props.position};
	background: ${(props) => props.background};
	color: ${(props) => props.color};
	align-self: ${(props) => props.alignSelf};
	display: flex;
	gap: ${(props) => props.gap};
	height: ${(props) => props.height};
	width: ${(props) => props.width};
	flex-direction: ${(props) => props.flexD};
	flex-wrap: ${(props) => props.flexWrap};
	justify-content: ${(props) => props.jContent};
	align-items: ${(props) => props.alignItem};
	padding: ${(props) => props.padding};
	margin: ${(props) => props.margin};
	text-align: ${(props) => props.txtAlign};
	font-size: ${(props) => props.fontSize};
	border-radius: ${(props) => props.borderRadius};
	z-index: ${(props) => props.zIndex};
`;

const Span = styled.span`
	font-size: ${(props) => props.fontSize};
	font-weight: ${(props) => props.fontWeight};
	font-family: ${(props) => props.fontFamily};
	color: ${(props) => props.color};
	margin: ${(props) => props.margin};
	padding: ${(props) => props.padding};
	width: ${(props) => props.width};
`;

const Status = styled.div`
	margin: ${(props) => props.margin};
	display: flex;
	justify-content: center;
	width: max-content;
	background: ${(props) => props.background};
	color: ${(props) => props.color};
	font-size: 0.8rem;
	padding: 1rem 2rem;
	border-radius: 10px;
`;

const CartItem = styled.div`
	border: 1px solid rgba(0, 0, 0, 0.2);
	box-sizing: border-box;
	border-radius: 18px;
	padding-left: 20px;
	padding-right: 20px;
	padding-top: 16px;
	padding-bottom: 16px;
	height: max-content;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-direction: row;
	margin-top: 18px;
`;

const Overlay = styled.div`
	position: fixed;
	display: flex;
	justify-content: center;
	align-items: center;
	background: rgba(0, 0, 0, 0.3);
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	z-index: 310;
`;

const Modal = styled.div`
	display: flex;
	flex-direction: column;
	background: #ffffff;
	height: max-content;
	width: 60%;
	border-radius: 10px;
	overflow-x: hidden;
	z-index: 305;
	@media (max-width: 600px) {
		width: 100%;
		height: 100%;
		overflow-y: scroll;
		border-radius: 0px;
	}
`;

const TabContain = styled.div`
	background: #fff;
	display: flex;
	width: max-content;
	align-items: center;
	padding: 0 0;
	margin: 1rem 1rem 1rem 1rem;
	border-radius: 10px;
`;

const Tab = styled.div`
	margin: 0;
	padding: 1rem;
	width: max-content;
	display: flex;
	z-index: 10;
	background: transparent;
	transition: 0.3s all linear;
`;

const Slider = styled.div`
	position: absolute;
	background: darkgrey;
	border-radius: 10px;
	transition: 0.2s all linear;
`;

const Popper = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	z-index: 2;
	display: flex;
	flex-direction: row;
`;

const yesterday = () => {
	let d = new Date();
	d.setDate(d.getDate() - 1);
	return d;
};

const FilterHead = styled.div`
	padding: 0.5rem 1rem;
	color: ${(props) => (props.active ? "#FFF" : "#000")};
	background: ${(props) => (props.active ? "rgba(45, 35, 66, 0.8)" : "#FFF")};
	border-radius: 10px;
`;

const DATA_MODES = {
	APPEND: "APPEND",
	REPLACE: "REPLACE",
};

function scrollToRequiredItem(id) {
	const element = document.getElementById(id);
	if (!element) return;
	element.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
}

const RecentOrders = (props) => {
	const { machineID, setOrders, orders, lastClickedElement, clearState, setLastClickedElement } = props;
	const { state } = useLocation();
	const preserveState = state?.preserveState && orders.length ? true : false;
	const [filters, setFilters] = useState({
		page: 1,
	});
	const [mode, setMode] = useState(preserveState ? DATA_MODES.APPEND : DATA_MODES.REPLACE);
	const [totalCount, setTotalCount] = useState(0);
	const [loading, setLoading] = useState(!preserveState);
	const [error, setError] = useState(false);
	const limitReached = useRef(false);
	const [lastElement, setLastElement] = useState();
	const navigate = useNavigate();
	const skipInitialCall = useRef(preserveState);

	const observer = useRef(
		new IntersectionObserver(
			(entries) => {
				if (entries[0].isIntersecting && !limitReached.current) {
					//Getting the earlier state and incrementing it
					setMode(DATA_MODES.APPEND);
					setFilters((prev) => ({ ...prev, page: prev.page + 1 }));
				}
			},
			{
				//Threshold set to 1 for the page to increment only when the element is 100% visible
				//Threshold = % of element to be visible / 100
				threshold: 1,
			}
		)
	);

	useEffect(() => {
		//Update the element on which the call is made and set the observer on it once the list re-renders
		const currentElement = lastElement;
		const currentObserver = observer.current;

		if (currentElement) {
			currentObserver.observe(currentElement);
		}

		//Remove the observer once user exits the page
		return () => {
			if (currentElement) {
				currentObserver.unobserve(currentElement);
			}
		};
	}, [lastElement]);

	useEffect(() => {
		if (preserveState && lastClickedElement) {
			scrollToRequiredItem(lastClickedElement.id);
		} else {
			clearState();
		}
	}, [preserveState]);

	useEffect(() => {
		if (skipInitialCall.current) {
			skipInitialCall.current = false;
			return;
		}
		//Fires everytime page changes
		fetchOrders(filters);
	}, [filters]);

	async function fetchOrders(filters) {
		if (limitReached.current) return;

		setLoading(true);
		setError(false);
		if (mode === DATA_MODES.REPLACE) {
			setOrders([]);
		}
		const response = await OrderService.getRecentOrders(machineID, filters);
		const { data, error } = response;
		setLoading(false);
		if (data) {
			const { orders: newOrders, totalOrdersCount } = data;

			if (mode === DATA_MODES.APPEND) {
				const totalOrders = [...orders, ...newOrders];
				if (totalOrders.length >= totalOrdersCount) {
					limitReached.current = true;
				}
				setOrders(totalOrders);
			} else {
				if (newOrders.length >= totalOrdersCount) {
					limitReached.current = true;
				}
				setOrders(newOrders);
			}
		}
		if (error) {
			errorNotification("Failed to Get Orders");
			setError(true);
		}
	}

	function renderOrders(orders) {
		if (!orders?.length) return;
		return (
			<Table>
				<Trow head>
					<Thead>Order Id</Thead>
					<Thead>Order Item Count</Thead>
					<Thead>Date</Thead>
					<Thead>Order Status</Thead>
					<Thead>Payment Status</Thead>
				</Trow>
				{orders.map((item, index, array) => {
					const isLastELement = array.length - 1 === index;

					return (
						<Trow
							innerRef={(node) => {
								if (isLastELement) setLastElement(node);
							}}
							id={item._id}
							key={item._id}
							onClick={() => {
								setLastClickedElement({ id: item._id });
								navigate(`/${machineID}/order/details/${item._id}`);
							}}>
							<Tcol borderRadius="10px 0 0 10px">{item._id}</Tcol>
							<Tcol borderRadius="10px 0 0 10px">{item.orderItemCount}</Tcol>
							<Tcol>{formatDisplayDate(item.createdAt)}</Tcol>
							<Tcol borderRadius="0 10px 10px 0">{item.status}</Tcol>
							<Tcol borderRadius="0 10px 10px 0">{item.paymentStatus}</Tcol>
						</Trow>
					);
				})}
			</Table>
		);
	}

	return (
		<Page>
			<Div flexWrap="wrap" margin="0 0 0 0" alignItem="center" jContent="space-between" width="100%">
				<Header>Recent Orders</Header>
			</Div>
			{!error && renderOrders(orders)}
			{loading && <Loader />}
			{error && !orders.length ? <EmptyState messsage="Something Went Wrong." retry={() => fetchOrders(filters)} /> : ""}
			{!loading && !error && !orders.length ? <EmptyState messsage="No Orders Found." retry={fetchOrders(filters)} /> : ""}
		</Page>
	);
};

const mapStatetoProps = (state) => {
	const { orders, landing } = state;
	return {
		machineID: landing.machineID,
		kitchenId: landing.kitchenId,
		...orders,
	};
};

const mapDispatchToProps = (dispatch) => ({
	...bindActionCreators(
		{
			...Actions,
		},
		dispatch
	),
});

export default connect(mapStatetoProps, mapDispatchToProps)(RecentOrders);
